<template>
  <form-inline
    :outdated="attempt.replaced_by_proposal_attempt_id"
    :current="commission.value_cents"
    :loading="loading"
    :class="classes"
    :mask="mask"
    @submit="submit"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import { depatternize } from '@sdk/helpers/formatters/patternize';

  import FormInline from '@cordel/components/Form/Inline.vue';

  export default {
    name: 'ProposalsReadCommission',
    components: {
      FormInline,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      attempt: {
        type: Object,
        default() {
          return {};
        },
      },
      type: {
        type: String,
        default: null,
        required: true,
      },
    },
    computed: {
      ...mapState([
        'proposalAttempts',
      ]),
      loading() {
        return this.proposalAttempts.commissionsUpdate.loading;
      },
      classes() {
        const classes = ['proposals-read-commission'];

        if (this.attempt.replaced_by_proposal_attempt_id) {
          classes.push('outdated-label-class');
        }

        return classes;
      },

      commission() {
        return (this.attempt.bank_commissions || []).find(i => i.commission_type === this.type) || {};
      },
      mask() {
        return {
          type: 'monetize',
        };
      },
    },
    mounted() {
      this.$store.dispatch('proposalAttempts/commissionsUpdateClear');
    },
    methods: {
      submit(value) {
        this.$store.dispatch('proposalAttempts/commissionsUpdate', {
          proposal_id: this.proposal.id,
          id: this.attempt.id,
          payload: {
            bank_commissions: [{
              commission_type: this.type,
              id: this.commission.id,
              value_cents: depatternize(value || 0),
            }],
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-commission {
  }

  .outdated-label-class {
    color: var(--cordel-legacy-color-neutral-primary);
  }
</style>
